import {templateEngine} from './templateEngine';
import {throttle} from '../modules/throttle';

var helpers = function () {
	return {
		'randomInteger': function(min, max){
			var rand = min - 0.5 + Math.random() * (max - min + 1)
			rand = Math.round(rand);
			return rand;
		},
		'templateEngine': templateEngine,
        'decline': function (number, titles) {
            var cases = [2, 0, 1, 1, 1, 2];
            return titles[ (number%100>4 && number%100<20)? 2 : cases[(number%10<5)?number%10:5] ];
        },
        'throttle': throttle
	}
};

export {helpers};